"use client"

import { useEffect } from 'react'

const GOOGLE_FONTS = [
  // Popular Sans-Serif
  'Inter:400,500,600,700',
  'Roboto:400,500,700',
  'Open+Sans:400,600,700',
  'Lato:400,700',
  'Montserrat:400,600,700',
  'Poppins:400,500,600,700',
  'Raleway:400,600,700',
  'Nunito:400,600,700',
  'Ubuntu:400,500,700',
  'Work+Sans:400,500,600,700',
  'Quicksand:400,500,600,700',
  'Josefin+Sans:400,600,700',
  'Barlow:400,500,600,700',
  'DM+Sans:400,500,700',
  'Rubik:400,500,600,700',
  'Karla:400,500,600,700',
  'Source+Sans+3:400,600,700',
  
  // Serif Fonts
  'Playfair+Display:400,700',
  'Merriweather:400,700',
  'Lora:400,600,700',
  'Crimson+Text:400,600,700',
  'Libre+Baskerville:400,700',
  'EB+Garamond:400,600,700',
  'Cormorant:400,600,700',
  'Spectral:400,600,700',
  'Bitter:400,600,700',
  'Cardo:400,700',
  
  // Display & Decorative
  'Bebas+Neue:400',
  'Abril+Fatface:400',
  'Righteous:400',
  'Anton:400',
  'Oswald:400,500,600,700',
  'Fjalla+One:400',
  'Archivo+Black:400',
  'Bangers:400',
  
  // Script & Handwriting
  'Pacifico:400',
  'Dancing+Script:400,700',
  'Caveat:400,700',
  'Permanent+Marker:400',
  'Indie+Flower:400',
  'Sacramento:400',
  'Great+Vibes:400',
  'Satisfy:400',
  
  // Monospace
  'Roboto+Mono:400,500,700',
  'Source+Code+Pro:400,500,600,700',
  'JetBrains+Mono:400,500,700',
  'Fira+Code:400,500,700',
  'Space+Mono:400,700',
]

export function FontLoader() {
  useEffect(() => {
    // Check if fonts are already loaded
    const existingLink = document.querySelector('link[data-font-loader]')
    if (existingLink) return

    // Create link element for Google Fonts
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.setAttribute('data-font-loader', 'true')
    link.href = `https://fonts.googleapis.com/css2?${GOOGLE_FONTS.map(f => `family=${f}`).join('&')}&display=swap`
    document.head.appendChild(link)

    return () => {
      // Clean up on unmount
      const linkToRemove = document.querySelector('link[data-font-loader]')
      if (linkToRemove) {
        document.head.removeChild(linkToRemove)
      }
    }
  }, [])

  return null
}


